/**
 * A higher order function that makes it easy and readable to an array.
 *
 * @example someArray.forEach(pushTo(otherArray));
 */
export function pushTo<T>(arr: T[]) {
  return (t: T) => arr.push(t);
}
